import areaResource from "../resources/areaResource";
import Area from "../domain/area";

export default {
  async findAll () {
    const response = await areaResource.query();
    if (response.ok) {
      return response.data.map((areaData) => new Area(areaData));
    } else {
      return null;
    }
  },
  async create (area) {
    const response = await areaResource.save({}, area);
    if (response.ok) {
      return new Area(response.data);
    } else {
      return null;
    }
  },
  async update (area) {
    const response = await areaResource.update({}, area);
    if (response.ok) {
      return new Area(response.data);
    } else {
      return null;
    }
  },
  async delete(id) {
    return areaResource.delete({id: id});
  },
  async deactivate (id) {
    return areaResource.deactivate({id: id}, {});
  },
  async activate (id) {
    return areaResource.activate({id: id}, {});
  }
}



// WEBPACK FOOTER //
// ./client/services/areaService.js